<template>
  <div class="box">
    <iframe class="iframe_content" :src="url" frameborder="0"></iframe>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { GET_HELP_URL } from '@/const/personalCenter'

export default {
  name: 'Help',
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
  },
  data() {
    return {
      url: '',
    };
  },
  async created() {
    await this.init()
  },
  methods: {
    async init() {
      const query = this.$route.query || {};
      delete query.pl
      const url = GET_HELP_URL(query)
      this.url = url
    }
  }
};
</script>

<style scoped lang="scss">
.box {
  width: 1024px;
  margin: 0 auto;
}
.iframe_content {
  width: 100%;
  max-width: 1024px;
  height: calc(100vh - 80px);
  overflow: auto;
}
</style>
